// Функция для перевода дат с русского на английский и обратно
window['translateDate'] = function (dateText, targetLang) {
  if (!dateText) return dateText;
  
  const monthsRu = {
    'января': 'January', 'февраля': 'February', 'марта': 'March', 'апреля': 'April',
    'мая': 'May', 'июня': 'June', 'июля': 'July', 'августа': 'August',
    'сентября': 'September', 'октября': 'October', 'ноября': 'November', 'декабря': 'December',
    'январь': 'January', 'февраль': 'February', 'март': 'March', 'апрель': 'April',
    'май': 'May', 'июнь': 'June', 'июль': 'July', 'август': 'August',
    'сентябрь': 'September', 'октябрь': 'October', 'ноябрь': 'November', 'декабрь': 'December'
  };
  
  const monthsEn = {
    'January': 'января', 'February': 'февраля', 'March': 'марта', 'April': 'апреля',
    'May': 'мая', 'June': 'июня', 'July': 'июля', 'August': 'августа',
    'September': 'сентября', 'October': 'октября', 'November': 'ноября', 'December': 'декабря'
  };
  
  // Сначала проверяем, содержит ли дата русский месяц
  let hasRussianMonth = false;
  for (const ruMonth of Object.keys(monthsRu)) {
    if (dateText.includes(ruMonth)) {
      hasRussianMonth = true;
      break;
    }
  }
  
  // Проверяем, содержит ли дата английский месяц
  let hasEnglishMonth = false;
  for (const enMonth of Object.keys(monthsEn)) {
    if (dateText.includes(enMonth)) {
      hasEnglishMonth = true;
      break;
    }
  }
  
  if (targetLang === 'en') {
    // Переводим с русского на английский
    if (hasRussianMonth) {
      for (const [ruMonth, enMonth] of Object.entries(monthsRu)) {
        if (dateText.includes(ruMonth)) {
          return dateText.replace(ruMonth, enMonth);
        }
      }
    }
  } else if (targetLang === 'ru') {
    // Переводим с английского на русский
    if (hasEnglishMonth) {
      for (const [enMonth, ruMonth] of Object.entries(monthsEn)) {
        if (dateText.includes(enMonth)) {
          return dateText.replace(enMonth, ruMonth);
        }
      }
    }
  }
  
  return dateText;
}

